import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import brands from "./brands.json";
import StoreProvider from "./store/StoreContext";
import NoFrame from "./NoFrame";
/* eslint-disable import/no-extraneous-dependencies */
import {DndProvider} from "react-dnd-multi-backend";
import {HTML5Backend} from "react-dnd-html5-backend";
import {TouchBackend} from "react-dnd-touch-backend";
import {MultiBackend, TouchTransition} from "react-dnd-multi-backend";

const CustomHTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend
    },
    {
      backend: TouchBackend,
      options: { enableMouseEvents: true }, // Note that you can call your backends with options
      preview: false,
      transition: TouchTransition
    }
  ]
};

const brand = "UNI";
document.documentElement.style.setProperty(
  "--data-color-primary",
  brands[brand].colors.primary
);
document.documentElement.style.setProperty(
  "--data-color-text",
  brands[brand].colors.text
);

// Won't render the application if WebApp is under Clickjacking attack
if(window.self === window.top) {
  ReactDOM.render(
    <React.StrictMode>
      <StoreProvider>
        <BrowserRouter>
          <DndProvider backend={MultiBackend} options={CustomHTML5toTouch}>
            <App />
          </DndProvider>
        </BrowserRouter>
      </StoreProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else{
  ReactDOM.render(<NoFrame />, document.getElementById("root"));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
